import { DataSharingStatus } from "../constants/DataSharingConstants";
import { PURCHASED_REPORT_SHORT_NAME } from "../components/inspections-table/InspectionsTable";

/**
 * Determines whether the data sharing opt-in banner/restrictions should be shown
 * @param dataSharingStatus - The current data sharing status (preferably from Redux state)
 * @param dataSharingAvailable - Whether data sharing is available for this inspection
 * @param inspectionTypeShortName - The short name of the inspection type
 * @returns true if the banner/restrictions should be shown, false otherwise, undefined if not applicable
 */
export const canShowDataSharingOptIn = (
    dataSharingStatus: DataSharingStatus | null | undefined,
    dataSharingAvailable?: boolean,
    inspectionTypeShortName?: string
): boolean | undefined => {
    if (inspectionTypeShortName === PURCHASED_REPORT_SHORT_NAME) {
        return undefined;
    }

    if (!dataSharingAvailable || dataSharingStatus === undefined || dataSharingStatus === null) {
        return undefined;
    }

    return dataSharingStatus === DataSharingStatus.DECISION_REQUIRED;
};
